import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 no-underline">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-semibold font-heading text-background-50">
                {siteInfo.name}
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              {siteInfo.slogan}
            </p>
            <p className="text-xs text-background-500 leading-relaxed">
              {siteInfo.description.slice(0, 80)}...
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">
              快速导航
            </h4>
            <ul className="space-y-3 list-none p-0 m-0">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors no-underline">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="text-sm text-background-400 hover:text-background-100 transition-colors no-underline">
                  全部分类
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors no-underline">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">
              热门分类
            </h4>
            <ul className="space-y-3 list-none p-0 m-0">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors no-underline"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">
              联系我们
            </h4>
            <ul className="space-y-3 list-none p-0 m-0">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-phone-line text-base"></i>
                <span>{siteInfo.contact.phone}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-base"></i>
                <span>{siteInfo.contact.email}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line text-base"></i>
                <span>{siteInfo.contact.address}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="w-full px-4 md:px-6 py-6">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors no-underline">
                隐私政策
              </a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors no-underline">
                服务条款
              </a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors no-underline">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}